import { render, staticRenderFns } from "./GoogleSignUp.vue?vue&type=template&id=87588718&scoped=true"
import script from "./GoogleSignUp.vue?vue&type=script&lang=js"
export * from "./GoogleSignUp.vue?vue&type=script&lang=js"
import style0 from "./GoogleSignUp.vue?vue&type=style&index=0&id=87588718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87588718",
  null
  
)

export default component.exports